// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"6c47c3a1","907":"58004a8e"}[chunkId] + ".chunk.css";
};